(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-header-menu"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.menu-item-li').forEach((item) => {
    item.addEventListener('mouseenter', function () {
      const parentDom = this.closest('.menu-item-dom');
      if (!parentDom) return;

      const index = Array.from(this.parentNode.children).indexOf(this);
      const colls = parentDom.querySelectorAll('.menu-item-coll');
      const allLis = parentDom.querySelectorAll('.menu-item-li');

      // 切换 active 类
      allLis.forEach((li) => li.classList.remove('menu-item-active'));
      this.classList.add('menu-item-active');

      colls.forEach((coll) => coll.classList.remove('item-coll-active'));
      if (colls[index]) {
        colls[index].classList.add('item-coll-active');
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
